import { api } from '@/lib/api-client';
import type { LoginInput, RegisterTenantInput } from './schemas';
import type { AuthUser } from './store';

interface AuthApiResponse {
  data: {
    user: AuthUser;
    accessToken: string;
    accessTokenExpiresAt: string;
  };
}

interface MeResponse {
  data: {
    id: string;
    tenantId: string;
    name: string;
    email: string;
    role: AuthUser['role'];
    active: boolean;
    phone: string | null;
    createdAt: string;
    lastLoginAt: string | null;
    tenant: {
      id: string;
      name: string;
      cnpj: string;
      status: string;
      plan: { code: string; name: string };
    };
  };
}

export async function apiLogin(input: LoginInput): Promise<AuthApiResponse['data']> {
  const { data } = await api.post<AuthApiResponse>('/auth/login', input);
  return data.data;
}

export async function apiRegisterTenant(
  input: RegisterTenantInput,
  /** Plano escolhido na landing. Omitido, o backend usa o trial. */
  planCode?: string,
): Promise<AuthApiResponse['data']> {
  const { acceptTerms: _accept, ...payload } = input;
  const { data } = await api.post<AuthApiResponse>('/auth/register-tenant', {
    ...payload,
    ...(planCode ? { planCode } : {}),
  });
  return data.data;
}

export async function apiRefresh(): Promise<AuthApiResponse['data'] | null> {
  try {
    const { data } = await api.post<AuthApiResponse>('/auth/refresh', {});
    return data.data;
  } catch {
    return null;
  }
}

export async function apiLogout(): Promise<void> {
  await api.post('/auth/logout', {}).catch(() => undefined);
}

export async function apiGetMe(): Promise<MeResponse['data']> {
  const { data } = await api.get<MeResponse>('/auth/me');
  return data.data;
}
